module.exports = __webpack_public_path__ + "img/title-books.40fc8715.png";